export default {
  install(V) { // 只有on off emit
    var _vm = new V(),
      _on = _vm.$on,
      _off = _vm.$off,
      _emit = _vm.$emit;
    _vm.$on = function (event, fn) {
      var _eventPrev = event;
      _on.call(_vm, _eventPrev, fn);
    };

    _vm.$emit = function (event, ...args) {
      var _eventPrev = event;
      _emit.call(_vm, _eventPrev, ...args);
    };

    _vm.$off = function (event) {
      var _eventPrev = event;
      _off.call(_vm, _eventPrev);
    };

    V.prototype.$eventBus = _vm;
  },
};



// WEBPACK FOOTER //
// ./src/base/stateManagement.js